import React from 'react';
import { connect } from 'react-redux';
import WAShareByTextContent from '../components/pages/waiting-area/share-by-text/content';

function WAShareByTextContainer(props) {
  return (
    <WAShareByTextContent
      waURLTextData={props.waURLTextData}
      waitingArea={props.waitingArea}
      isWAEntryPointAdditionalMsgAllowed={props.isWAEntryPointAdditionalMsgAllowed}
      dispatch={props.dispatch}
    />
  );
}
function mapStateToProps(state) {
  return {
    waURLTextData: state.waitingAreaReducer.waURLTextData,
    isWAEntryPointAdditionalMsgAllowed: state.usersReducer.userProfile.isWAEntryPointAdditionalMsgAllowed,
  };
}

export default connect(mapStateToProps, null)(WAShareByTextContainer);
